import { render, staticRenderFns } from "./IndicationsView.vue?vue&type=template&id=7af8add8&scoped=true&"
import script from "./IndicationsView.vue?vue&type=script&lang=js&"
export * from "./IndicationsView.vue?vue&type=script&lang=js&"
import style0 from "./IndicationsView.vue?vue&type=style&index=0&id=7af8add8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af8add8",
  null
  
)

export default component.exports